import { render } from "./protocol_memorandum.vue?vue&type=template&id=10c4ac57&scoped=true"
import script from "./protocol_memorandum.vue?vue&type=script&lang=js"
export * from "./protocol_memorandum.vue?vue&type=script&lang=js"

import "./protocol_memorandum.vue?vue&type=style&index=0&id=10c4ac57&scoped=true&lang=css"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10c4ac57"],['__file',"vue/js/components/sale/protocol/create/tabs/protocol_memorandum.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "10c4ac57"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('10c4ac57', __exports__)) {
    console.log('reload')
    api.reload('10c4ac57', __exports__)
  }
  
  module.hot.accept("./protocol_memorandum.vue?vue&type=template&id=10c4ac57&scoped=true", () => {
    console.log('re-render')
    api.rerender('10c4ac57', render)
  })

}


export default __exports__